import 'vue';
import './helpers.js';
import './config.js';
import { b as registerComponent } from './plugins-6a50b8eb.js';
import './MatchMediaMixin-d82eb550.js';
import './trapFocus-5a175a55.js';
import { s as script, a as script$1 } from './DropdownItem-c6a66909.js';
export { s as ODropdown, a as ODropdownItem } from './DropdownItem-c6a66909.js';

var index = {
    install(app) {
        registerComponent(app, script);
        registerComponent(app, script$1);
    }
};

export default index;
